"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgManual = function SvgManual(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 22h-6.5a4 4 0 01-2.89-1.23L2 13.91v-.06l2-1.8a2 2 0 012.26-.27l1.61.54h.06V6.78a2.5 2.5 0 012.5-2.5 2.94 2.94 0 01.51 0 2.49 2.49 0 014.55-1.24 2.21 2.21 0 01.77-.17A2.64 2.64 0 0119 5.62v.07a2.73 2.73 0 01.5-.05 2.5 2.5 0 012.5 2.5V18a4 4 0 01-4 4zM4.88 14L10 19.38a2 2 0 001.44.62H18a2.05 2.05 0 002-2V8.14a.5.5 0 10-1 0V12h-1.9-.1V5.41a.5.5 0 00-1 0V12h-1.9-.1V4.5a.5.5 0 00-1 0V12h-1.9-.1V6.78a.5.5 0 00-.5-.5.5.5 0 00-.5.5v8.81s0 .05-.07 0l-4.54-2.04z",
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 24V0h24v24z",
    fill: "none"
  }));
};

var _default = SvgManual;
exports["default"] = _default;